import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ArrowCurvedUpFlippedIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M5.76 11.42L4.54 10.2L11.3 3.44L18.06 10.2L16.84 11.42L12.32 6.84V13.62C12.32 15.56 13.82 17.08 15.7 17.08H20.24V19H15.7C12.64 19 10.32 16.68 10.32 13.62V6.8L5.76 11.42Z" />
    </SvgIcon>
  );
});
